export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  excerpt: string;
  content: string;
  imageUrl: string;
  author: string;
  publishDate: string;
  readTime: number;
  tags: string[];
  featured: boolean;
}

export const allArticles: Article[] = [
  {
    id: 'art-001',
    title: '91免费版最新版本v4.2.0发布：全新界面与性能大幅提升',
    slug: 'latest-version-4-2-0-release',
    category: 'system-tools',
    excerpt: '91免费版v4.2.0正式发布，带来了全新的用户界面设计，启动速度提升40%，内存占用降低30%，同时还新增了批量处理功能，让工具使用更加高效便捷。',
    content: `<h2>全新界面设计，体验全面升级</h2><p>91免费版v4.2.0采用了全新的界面设计语言，整体风格更加简洁现代。我们重新设计了工具栏布局，让常用功能更加触手可及。新的暗色模式支持也让长时间使用的用户获得更舒适的视觉体验。</p><p>新版界面采用了自适应布局，在不同分辨率的屏幕上都能完美呈现。图标系统全面更新，使用统一的设计语言，辨识度更高。</p><h2>性能大幅提升</h2><p>经过底层架构的全面优化，v4.2.0版本的启动速度相比上一版本提升了40%。我们重构了核心模块的加载机制，实现了按需加载，让软件在启动时只加载必要的组件。</p><p>内存占用方面，通过优化数据结构和缓存策略，在同等使用场景下内存占用降低了30%。对于配置较低的设备来说，这是一个非常实用的改进。</p><h2>新增批量处理功能</h2><p>v4.2.0最受期待的新功能之一就是批量处理。现在你可以一次性选择多个文件进行操作，无论是格式转换、重命名还是压缩，都能批量完成，大幅提升工作效率。</p><p>批量处理的进度显示也更加直观，你可以清楚地看到每个文件的处理状态，遇到问题时还能单独重试失败的文件。</p><h2>安装与升级指南</h2><p>如果你是新用户，可以直接访问官网下载页面获取最新版本。对于老用户，打开软件后会自动提示更新，点击"立即更新"即可完成升级。整个升级过程不会影响已有的设置和数据。</p><p>需要特别说明的是，v4.2.0版本要求操作系统版本不低于Windows 10 21H2或macOS 12 Monterey，请确保你的系统满足最低要求。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20software%20interface%20design%20with%20clean%20minimalist%20UI%2C%20light%20mode%20dashboard%20with%20charts%20and%20tools%2C%20soft%20warm%20ambient%20lighting%2C%20professional%20product%20screenshot%2C%20high%20detail%2C%20harmonious%20composition%2C%20neutral%20warm%20background&width=800&height=450&seq=article-001&orientation=landscape',
    author: '91免费版团队',
    publishDate: '2026-07-28',
    readTime: 8,
    tags: ['版本更新', '性能优化', '新功能'],
    featured: true,
  },
  {
    id: 'art-002',
    title: '91免费版安装教程：从下载到使用的完整指南',
    slug: 'complete-installation-guide',
    category: 'system-tools',
    excerpt: '本文提供91免费版的完整安装教程，涵盖Windows和macOS两个平台，从下载、安装到首次使用的每一个步骤，帮助新手用户快速上手。',
    content: `<h2>下载91免费版</h2><p>首先，访问91免费版官方网站，在首页点击"免费下载"按钮。网站会自动检测你的操作系统并推荐对应的安装包。你也可以在下载页面手动选择Windows版或macOS版。</p><p>下载完成后，请核对安装包的MD5校验值，确保文件完整无误。校验值可以在下载页面找到。</p><h2>Windows系统安装步骤</h2><p>双击下载的.exe安装文件，如果系统弹出安全警告，点击"运行"继续。在安装向导中，你可以选择安装路径，建议保持默认设置。安装过程大约需要1-2分钟，完成后会在桌面创建快捷方式。</p><h2>macOS系统安装步骤</h2><p>打开下载的.dmg文件，将91免费版图标拖拽到Applications文件夹中。首次打开时，如果系统提示"无法验证开发者"，请前往系统偏好设置 → 安全性与隐私中点击"仍要打开"。</p><h2>首次使用配置</h2><p>安装完成后打开软件，首次启动会引导你完成基本配置，包括语言选择、界面主题、默认工具偏好等。这些设置之后可以在设置菜单中随时修改。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Computer%20screen%20showing%20software%20installation%20process%2C%20clean%20minimalist%20desktop%20setup%2C%20step%20by%20step%20guide%20visual%2C%20warm%20lighting%2C%20professional%20workspace%2C%20soft%20neutral%20background&width=800&height=450&seq=article-002&orientation=landscape',
    author: '技术小编',
    publishDate: '2026-07-25',
    readTime: 10,
    tags: ['安装教程', '新手入门', '下载指南'],
    featured: true,
  },
  {
    id: 'art-003',
    title: '如何使用91免费版进行PDF文件转换与编辑',
    slug: 'pdf-conversion-editing-guide',
    category: 'office-tools',
    excerpt: '91免费版内置了强大的PDF处理工具，支持PDF与Word、Excel、PPT等格式的互转，还提供了PDF合并、拆分、压缩等实用功能，完全免费。',
    content: `<h2>PDF格式转换功能概述</h2><p>91免费版的PDF工具支持多种格式之间的相互转换，包括PDF转Word、PDF转Excel、PDF转PPT、PDF转图片，以及反向的Word、Excel、PPT转PDF。所有转换功能均保持原始排版，确保转换后的文档格式完整。</p><h2>PDF转Word实操教程</h2><p>打开91免费版，在工具列表中选择"PDF工具"，点击"PDF转Word"。将需要转换的PDF文件拖入窗口或点击选择文件。选择转换模式（可编辑模式或保留排版模式），点击"开始转换"。转换完成后会自动打开文件所在文件夹。</p><h2>PDF合并与拆分</h2><p>合并功能支持将多个PDF文件按顺序合并为一个文件。你可以在预览界面中拖拽调整页面顺序，删除不需要的页面。拆分功能则支持按页数、按文件大小或手动选择页面范围进行拆分。</p><h2>PDF压缩优化</h2><p>91免费版的PDF压缩功能采用了智能压缩算法，可以在保持清晰度的前提下将文件大小减少60%-80%。你可以在压缩前预览效果，并根据需要调整压缩强度。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=PDF%20document%20editing%20software%20interface%2C%20clean%20modern%20UI%20with%20document%20preview%20and%20tool%20panels%2C%20professional%20office%20setting%2C%20warm%20ambient%20light%2C%20neutral%20background&width=800&height=450&seq=article-003&orientation=landscape',
    author: '办公达人',
    publishDate: '2026-07-20',
    readTime: 7,
    tags: ['PDF工具', '格式转换', '办公技巧'],
    featured: false,
  },
  {
    id: 'art-004',
    title: '91免费版视频剪辑功能详解：零基础也能快速上手',
    slug: 'video-editing-features-guide',
    category: 'multimedia',
    excerpt: '91免费版内置的视频剪辑工具支持剪辑、合并、添加字幕、调整速度等常用功能，本文详细讲解每个功能的使用方法和技巧，帮助零基础用户快速成为剪辑高手。',
    content: `<h2>视频剪辑基础操作</h2><p>打开91免费版的视频工具模块，导入需要编辑的视频文件。在时间轴上你可以直观地看到视频的每一帧。通过拖动时间轴两端的手柄，可以精确选择需要保留的片段。选中不需要的片段后，点击"剪切"按钮即可删除。</p><h2>视频合并与转场</h2><p>如果你需要将多个视频片段合并成一个完整的视频，可以使用合并功能。将多个视频按顺序添加到时间轴上，在片段之间可以添加转场效果。91免费版提供了20多种转场特效供你选择。</p><h2>添加字幕与文字</h2><p>字幕功能支持手动输入和自动语音识别两种方式。自动语音识别支持中文和英文，识别准确率高达95%以上。你还可以自定义字幕的字体、大小、颜色和位置。</p><h2>视频导出设置</h2><p>编辑完成后，点击"导出"按钮。你可以选择输出格式（MP4、MOV、AVI等）、分辨率（最高支持4K）和码率。软件会根据你的设置预估文件大小，方便你根据需要调整参数。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Video%20editing%20software%20timeline%20interface%2C%20clean%20modern%20UI%20with%20preview%20window%20and%20editing%20tools%2C%20professional%20creative%20workspace%2C%20warm%20lighting%2C%20soft%20neutral%20background&width=800&height=450&seq=article-004&orientation=landscape',
    author: '剪辑小能手',
    publishDate: '2026-07-18',
    readTime: 12,
    tags: ['视频剪辑', '多媒体', '新手教程'],
    featured: false,
  },
  {
    id: 'art-005',
    title: '91免费版数据恢复工具：找回误删文件的终极方案',
    slug: 'data-recovery-ultimate-guide',
    category: 'network-tools',
    excerpt: '不小心删除了重要文件？91免费版的数据恢复工具可以帮助你从硬盘、U盘、SD卡等存储设备中恢复误删的文件，支持多种文件格式，恢复成功率高达90%。',
    content: `<h2>数据恢复原理</h2><p>当文件被删除时，操作系统并不会立即清除文件数据，而是将文件占用的空间标记为"可用"。在新的数据写入之前，被删除的文件数据仍然存在于硬盘上。91免费版的数据恢复工具正是利用这一原理，通过深度扫描找到这些"已删除但未覆盖"的数据。</p><h2>使用前的注意事项</h2><p>发现文件被误删后，最重要的一点是：立即停止对该磁盘的任何写入操作。不要在丢失文件的磁盘上安装软件、下载文件或创建新文件，这些操作可能会覆盖被删除文件的数据，导致无法恢复。</p><h2>恢复操作步骤</h2><p>打开91免费版，选择"数据恢复"工具。选择需要扫描的磁盘分区，点击"开始扫描"。扫描时间取决于磁盘大小，可能需要几分钟到几十分钟不等。扫描完成后，在结果列表中查找需要恢复的文件，选中后点击"恢复"并选择保存位置。注意：恢复的文件不要保存到原来的磁盘分区，以免覆盖其他待恢复数据。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Data%20recovery%20software%20scanning%20interface%2C%20file%20recovery%20progress%20screen%2C%20clean%20modern%20tech%20UI%2C%20dark%20warm%20tone%2C%20professional%20digital%20forensic%20aesthetic&width=800&height=450&seq=article-005&orientation=landscape',
    author: '数据救援师',
    publishDate: '2026-07-15',
    readTime: 9,
    tags: ['数据恢复', '文件找回', '安全工具'],
    featured: true,
  },
  {
    id: 'art-006',
    title: '企业团队如何利用91免费版提升办公效率',
    slug: 'team-productivity-with-91free',
    category: 'office-tools',
    excerpt: '越来越多的企业团队选择91免费版作为办公辅助工具。本文分享5个真实的企业使用案例，展示如何通过91免费版提升团队协作效率和日常办公体验。',
    content: `<h2>案例一：文档批量处理</h2><p>某互联网公司的运营团队每天需要处理上百份合同和报告。使用91免费版的批量处理功能后，原本需要3小时的文档格式转换工作缩短到了30分钟，效率提升了6倍。</p><h2>案例二：远程协作支持</h2><p>一家设计公司的团队成员分布在不同城市，通过91免费版的远程协助和文件共享功能，实现了无缝的远程协作。屏幕共享和实时标注功能让设计评审更加高效。</p><h2>案例三：数据安全管理</h2><p>某金融科技团队使用91免费版的加密工具对所有敏感文件进行加密保护。通过设置不同级别的访问权限，确保了客户数据的安全性，同时不影响日常工作效率。</p><h2>总结</h2><p>91免费版提供了全面且实用的工具集，对于追求高效协作的团队来说是一个不可多得的利器。最重要的是，所有这些功能都是完全免费的，无需任何预算投入。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20office%20team%20collaboration%20scene%2C%20diverse%20people%20working%20on%20laptops%2C%20clean%20bright%20workspace%2C%20professional%20atmosphere%2C%20warm%20natural%20light%2C%20soft%20neutral%20background&width=800&height=450&seq=article-006&orientation=landscape',
    author: '效率顾问',
    publishDate: '2026-07-12',
    readTime: 8,
    tags: ['企业办公', '效率提升', '团队协作'],
    featured: false,
  },
  {
    id: 'art-007',
    title: '91免费版安全防护功能全面评测',
    slug: 'security-features-review',
    category: 'security-tools',
    excerpt: '我们对91免费版内置的安全防护功能进行了全面评测，包括病毒查杀、隐私清理、网络防护等模块，并与主流安全软件进行了横向对比。',
    content: `<h2>病毒查杀能力测试</h2><p>我们使用包含5000+病毒样本的测试集对91免费版的查杀引擎进行了测试。结果显示，91免费版的病毒检出率达到了98.7%，与主流付费杀毒软件处于同一水平。扫描速度方面，全盘扫描用时12分钟，比同类产品快约20%。</p><h2>隐私保护功能</h2><p>91免费版的隐私清理功能可以深度清理浏览器历史、Cookie、临时文件等可能泄露隐私的数据。在测试中，单次清理可释放500MB-2GB的磁盘空间，同时有效清除了所有可追踪的浏览痕迹。</p><h2>网络防护模块</h2><p>网络防护模块提供了实时流量监控、恶意网站拦截和WiFi安全检测功能。在我们的测试中，恶意网站拦截成功率达到96%。WiFi安全检测能有效识别钓鱼热点和不安全的网络连接。</p><h2>总结评价</h2><p>作为一款免费工具，91免费版的安全防护功能表现出色。对于普通用户来说，它完全能够满足日常安全需求。对于有更高安全要求的用户，建议配合其他专业安全工具使用。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cybersecurity%20shield%20concept%2C%20digital%20protection%20visual%2C%20clean%20modern%20security%20dashboard%2C%20warm%20teal%20accents%2C%20professional%20tech%20aesthetic%2C%20soft%20neutral%20background&width=800&height=450&seq=article-007&orientation=landscape',
    author: '安全评测师',
    publishDate: '2026-07-10',
    readTime: 11,
    tags: ['安全防护', '病毒查杀', '功能评测'],
    featured: false,
  },
  {
    id: 'art-008',
    title: '91免费版开发者工具：提升编程效率的隐藏宝藏',
    slug: 'developer-tools-hidden-gems',
    category: 'dev-tools',
    excerpt: '很多用户不知道91免费版还内置了实用的开发者工具。本文带你了解JSON格式化、正则表达式测试、Base64编解码、API调试等开发者常用功能。',
    content: `<h2>JSON格式化与验证</h2><p>91免费版的JSON工具支持一键格式化和压缩JSON数据，同时提供语法验证功能。当JSON格式有误时，会精确指出错误位置，帮助开发者快速定位问题。</p><h2>正则表达式测试器</h2><p>内置的正则表达式测试工具支持实时匹配预览，你可以在输入正则表达式的同时看到匹配结果。工具提供了常用正则表达式的模板库，涵盖了邮箱、手机号、URL等常见验证场景。</p><h2>编解码工具集</h2><p>Base64、URL编码、Unicode转换、MD5/SHA哈希计算等常用编解码功能一应俱全。支持批量处理，可以一次性对多个字符串进行编码或解码。</p><h2>API调试工具</h2><p>轻量级的API调试工具支持GET、POST、PUT、DELETE等常用HTTP方法，可以自定义请求头和请求体，响应结果支持JSON格式化显示。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Code%20editor%20interface%20with%20JSON%20formatter%20tool%2C%20clean%20dark%20theme%20developer%20workspace%2C%20modern%20programming%20environment%2C%20warm%20accent%20highlights%2C%20professional%20tech%20aesthetic&width=800&height=450&seq=article-008&orientation=landscape',
    author: '全栈开发者',
    publishDate: '2026-07-08',
    readTime: 6,
    tags: ['开发工具', '编程效率', '实用技巧'],
    featured: false,
  },
  {
    id: 'art-009',
    title: '91免费版网络加速工具使用指南：让下载速度飞起来',
    slug: 'network-acceleration-guide',
    category: 'network-tools',
    excerpt: '91免费版的网络加速工具通过智能节点选择和协议优化，能够显著提升下载速度。本文详细介绍加速原理、使用方法和高级配置技巧。',
    content: `<h2>网络加速原理</h2><p>91免费版的网络加速工具采用多线程下载技术和智能节点调度算法。普通浏览器或下载工具通常使用单线程下载，而91免费版会将文件分为多个片段同时下载，充分利用带宽资源。</p><p>此外，加速工具内置了全球CDN节点列表，会自动选择延迟最低、速度最快的节点进行连接，有效规避网络拥堵。</p><h2>基础使用方法</h2><p>打开91免费版的网络工具模块，选择"下载加速"。将需要下载的文件链接粘贴到地址栏，点击"开始下载"。加速工具会自动分析链接并选择最优下载策略。</p><h2>高级配置技巧</h2><p>在设置中你可以手动调整线程数（建议4-8个线程）、选择特定区域的CDN节点、设置下载限速以免影响其他网络活动，还可以配置下载完成后的自动操作，如自动关机等。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Network%20speed%20concept%20visualization%2C%20digital%20data%20transfer%20with%20fast%20connection%20lines%2C%20clean%20modern%20tech%20aesthetic%2C%20warm%20accent%20tone%2C%20professional%20network%20visual&width=800&height=450&seq=article-009&orientation=landscape',
    author: '网络优化师',
    publishDate: '2026-07-05',
    readTime: 7,
    tags: ['网络加速', '下载工具', '使用教程'],
    featured: false,
  },
];